// ============================================================
// Cozy Heaven Sleep Quiz - Gamified, German, Cloud Mascot
// ============================================================

// ---------- CLOUD INSIGHTS (shown between questions) ----------
const cloudInsights = {
  // After question index -> insight shown before next question
  1: {
    face: '🤔',
    text: '<span class="insight-emoji">💡</span>Wusstest du? <strong>67% der Deutschen</strong> sagen, dass Stress ihr größter Schlaf-Killer ist. Aber die wenigsten wissen, dass es nicht der Stress selbst ist - sondern wie der Körper ihn <em>festhält</em>.'
  },
  3: {
    face: '😮',
    text: '<span class="insight-emoji">🧪</span>Fun Fact: Dein Gehirn spielt nachts die Erlebnisse des Tages nochmal durch - wie ein Film-Editor. <strong>Die richtigen Sounds können diesen Prozess beschleunigen</strong> und dir helfen, schneller in den Tiefschlaf zu kommen.'
  },
  5: {
    face: '🤓',
    text: '<span class="insight-emoji">🌡️</span>Fast geschafft! Übrigens: Deine ideale Einschlaf-Temperatur liegt bei <strong>genau 18,3°C</strong>. Nicht 18. Nicht 19. Forscher der Stanford University haben das auf die Nachkommastelle genau bestimmt.'
  },
};

// ---------- QUIZ DATA ----------
const questions = [
  {
    id: 'sleep_struggle',
    type: 'multi',
    label: 'Schlafprofil',
    text: 'Was ist dein größtes Schlafproblem?',
    sub: 'Wähle alles, was auf dich zutrifft.',
    options: [
      { icon: '🧠', label: 'Gedankenkarussell', desc: 'Mein Kopf schaltet einfach nicht ab', value: 'racing_thoughts' },
      { icon: '😰', label: 'Stress & Anspannung', desc: 'Ich nehme den ganzen Tag mit ins Bett', value: 'stress' },
      { icon: '🔄', label: 'Hin und her wälzen', desc: 'Ich finde einfach keine bequeme Position', value: 'restless' },
      { icon: '⏰', label: 'Zu früh aufwachen', desc: 'Einschlafen klappt, aber um 3 Uhr bin ich wach', value: 'early_wake' },
      { icon: '📱', label: 'Bildschirm-Sucht', desc: 'Ich scrolle viel zu lange vor dem Schlafen', value: 'screens' },
      { icon: '✏️', label: 'Etwas anderes', desc: 'Mein Problem ist anders', value: 'other', isOther: true },
    ]
  },
  {
    id: 'awake_trigger',
    type: 'multi',
    label: 'Wachhalter',
    text: 'Was hält dich abends am meisten wach?',
    sub: 'Wähle alles, was auf dich zutrifft.',
    options: [
      { icon: '💼', label: 'Arbeit im Kopf', desc: 'Die To-Do-Liste für morgen läuft auf Repeat', value: 'work' },
      { icon: '💬', label: 'Soziale Grübeleien', desc: 'Gespräche und Situationen, die ich immer wieder durchgehe', value: 'social' },
      { icon: '🫀', label: 'Körperliche Anspannung', desc: 'Verspannte Muskeln, unruhige Beine', value: 'physical' },
      { icon: '🌡️', label: 'Temperatur', desc: 'Zu warm oder zu kalt zum Entspannen', value: 'temperature' },
      { icon: '🔊', label: 'Geräuschempfindlichkeit', desc: 'Jedes kleine Geräusch hält mich wach', value: 'noise' },
      { icon: '✏️', label: 'Etwas anderes', desc: 'Was anderes hält mich wach', value: 'other', isOther: true },
    ]
  },
  {
    id: 'safe_feeling',
    type: 'freetext',
    label: 'Geborgenheit',
    text: 'Denk an das letzte Mal, als du richtig gut eingeschlafen bist.',
    sub: 'Wo warst du? Beschreib den Moment - deine Playlist wird darauf abgestimmt.',
    placeholder: 'Erzähl uns davon...',
    minLength: 20,
    chips: [
      { label: '🌧️ Es hat geregnet', text: 'Es hat draußen leicht geregnet. ' },
      { label: '🏔️ Im Urlaub', text: 'Ich war im Urlaub. ' },
      { label: '🛋️ Auf dem Sofa', text: 'Ich lag auf dem Sofa. ' },
      { label: '🧸 Schwere Decke', text: 'Ich hatte eine schwere Decke. ' },
      { label: '🤫 Total still', text: 'Es war komplett still. ' },
      { label: '🕯️ Gedämmtes Licht', text: 'Das Licht war ganz gedämmt. ' },
      { label: '🌊 Am Meer', text: 'Ich konnte das Meer hören. ' },
      { label: '📖 Nach dem Lesen', text: 'Ich hatte vorher gelesen. ' },
      { label: '🎙️ Hörbuch lief', text: 'Im Hintergrund lief ein Hörbuch oder eine Stimme. ' },
      { label: '👂 Jemand erzählte', text: 'Jemand hat mir etwas erzählt. ' },
    ]
  },
  {
    id: 'tired_trigger',
    type: 'multi',
    label: 'Entspannung',
    text: 'Was macht dich wirklich müde und schlafbereit?',
    sub: 'Wähle alles, was auf dich zutrifft.',
    options: [
      { icon: '🏃', label: 'Körperliche Erschöpfung', desc: 'Nach Sport oder einem langen aktiven Tag', value: 'exercise' },
      { icon: '🛁', label: 'Heißes Bad oder Dusche', desc: 'Wärme, die alle Anspannung löst', value: 'bath' },
      { icon: '📚', label: 'Etwas Langweiliges lesen', desc: 'Meine Augen werden schwer beim Lesen', value: 'reading' },
      { icon: '🧘', label: 'Tiefes Atmen oder Meditation', desc: 'Gezielte Ruhe lässt mich abdriften', value: 'meditation' },
      { icon: '🎵', label: 'Leise Hintergrundmusik', desc: 'Sanfte Klänge tragen mich davon', value: 'music' },
      { icon: '🎙️', label: 'Hörbuch oder Sleep Story', desc: 'Eine ruhige Stimme erzählt mir was', value: 'voice' },
      { icon: '✏️', label: 'Etwas anderes', desc: 'Etwas anderes macht mich müde', value: 'other', isOther: true },
    ]
  },
  {
    id: 'sound_preference',
    type: 'multi',
    label: 'Klangwelt',
    text: 'Welche Klänge sprechen dich zum Einschlafen am meisten an?',
    sub: 'Wähle alles, was dir gefällt - deine Playlist wird daraus zusammengestellt.',
    options: [
      { icon: '🌊', label: 'Ozean & Wasser', desc: 'Wellen, Flüsse, Regen', value: 'water' },
      { icon: '🎹', label: 'Sanftes Piano & Streicher', desc: 'Zarte instrumentale Musik', value: 'piano' },
      { icon: '🗣️', label: 'Sanfte Stimmen & Geschichten', desc: 'Sleep Stories, Hörbücher, ASMR', value: 'voice' },
      { icon: '🌌', label: 'Ambient & Elektronisch', desc: 'Traumhafte Synth-Pads, Lo-Fi', value: 'ambient' },
      { icon: '🌲', label: 'Wald & Natur', desc: 'Vögel, Grillen, Wind in den Bäumen', value: 'forest' },
      { icon: '🔇', label: 'Weißes/Braunes Rauschen', desc: 'Gleichmäßige Töne, Brummen, Statik', value: 'noise' },
      { icon: '✏️', label: 'Etwas anderes', desc: 'Andere Klänge entspannen mich', value: 'other', isOther: true },
    ]
  },
  {
    id: 'sleep_time',
    type: 'single',
    label: 'Routine',
    text: 'Wann versuchst du normalerweise einzuschlafen?',
    sub: 'Dein Schlaf-Timing beeinflusst, welche Frequenzen am besten wirken.',
    options: [
      { icon: '🌆', label: 'Vor 22 Uhr', desc: 'Ich gehe früh ins Bett', value: 'early' },
      { icon: '🌙', label: '22–24 Uhr', desc: 'Ziemlich normale Schlafenszeit', value: 'normal' },
      { icon: '🦉', label: 'Nach Mitternacht', desc: 'Ich bin eine Nachteule', value: 'late' },
      { icon: '🔀', label: 'Total unterschiedlich', desc: 'Kein festes Muster, ehrlich gesagt', value: 'irregular' },
    ]
  },
  {
    id: 'goal',
    type: 'multi',
    label: 'Dein Ziel',
    text: 'Was würde besserer Schlaf in deinem Leben verändern?',
    sub: 'Letzte Frage - damit personalisieren wir deine Empfehlung.',
    options: [
      { icon: '⚡', label: 'Mehr Energie tagsüber', desc: 'Ich bin erschöpft und es beeinflusst alles', value: 'energy' },
      { icon: '😌', label: 'Weniger Stress & Angst', desc: 'Ich will mich ruhig fühlen, nicht aufgedreht', value: 'calm' },
      { icon: '🧠', label: 'Klarerer Kopf', desc: 'Brain Fog killt meine Produktivität', value: 'clarity' },
      { icon: '❤️', label: 'Bessere Stimmung', desc: 'Schlechter Schlaf macht mich reizbar', value: 'mood' },
      { icon: '💪', label: 'Körperliche Erholung', desc: 'Mein Körper braucht echte Ruhe', value: 'recovery' },
      { icon: '✏️', label: 'Etwas anderes', desc: 'Ein anderes Ziel', value: 'other', isOther: true },
    ]
  }
];

// ---------- SLEEP TYPE PROFILES ----------
const sleepTypes = {
  deep_dreamer: {
    name: 'Der Tiefträumer',
    title: 'Du bist ein Tiefträumer',
    description: 'Dein Kopf ist dein größtes Schlafhindernis. Du brauchst Klänge, die deine Aufmerksamkeit sanft von den Gedanken wegziehen und in eine traumhafte Klanglandschaft eintauchen lassen.',
    playlistId: '7vGzetucDJ5aI7LJsU4Ep8',
    playlistName: 'Cozy Heaven · Mind Off',
    playlistUrl: 'https://open.spotify.com/playlist/7vGzetucDJ5aI7LJsU4Ep8',
    songCount: 24,
    tips: [
      {
        icon: '🧠',
        text: '<strong>Brain Dump vor dem Schlafen.</strong> Schreib die Aufgaben für morgen auf Papier - raus aus dem Kopf, rauf aufs Blatt.',
        science: 'Dein Gehirn hält offene Aufgaben aktiv im Arbeitsgedächtnis (Zeigarnik-Effekt). Sobald du sie aufschreibst, signalisierst du dem präfrontalen Cortex: "erledigt - du kannst loslassen". Eine Studie der Baylor University zeigte, dass Probanden, die vor dem Schlafen eine To-Do-Liste schrieben, 9 Minuten schneller einschliefen.'
      },
      {
        icon: '🌡️',
        text: '<strong>Zimmer auf 18°C kühlen.</strong> Dein Gehirn braucht einen Temperaturabfall, um Melatonin auszuschütten.',
        science: 'Deine Kerntemperatur fällt während des Schlafs natürlich um 1-2°C. Ein kühles Zimmer beschleunigt diesen Prozess. Bei zu warmen Räumen muss dein Körper aktiv kühlen (Schwitzen), was REM-Schlaf unterbricht. 18°C ist der Sweet Spot - kalt genug für Melatonin-Produktion, warm genug zum Komfortabel-Liegen.'
      },
      {
        icon: '📱',
        text: '<strong>30 Min. vor dem Schlafen kein Bildschirm.</strong> Blaues Licht unterdrückt Melatonin um bis zu 50%.',
        science: 'Blaues Licht (480 nm Wellenlänge) trifft Melanopsin-Rezeptoren in deiner Netzhaut, die direkt mit dem suprachiasmatischen Kern verbunden sind - deiner inneren Uhr. Das Signal: "Es ist Tag". Die Folge: Melatonin-Produktion stoppt. Eine Harvard-Studie zeigte, dass 6,5 Stunden Bildschirmzeit am Abend Melatonin um 50% reduzieren.'
      },
    ]
  },
  body_melter: {
    name: 'Der Körperschmelzer',
    title: 'Du bist ein Körperschmelzer',
    description: 'Körperliche Anspannung hält dich wach. Du brauchst Klänge, die das Gefühl des Einsinkens spiegeln - tiefe Basstöne, langsame rhythmische Muster und warme Frequenzen.',
    playlistId: '1DDzkAO4xFm6uoXHlQTWBK',
    playlistName: 'Cozy Heaven · Body Melt',
    playlistUrl: 'https://open.spotify.com/playlist/1DDzkAO4xFm6uoXHlQTWBK',
    songCount: 28,
    tips: [
      {
        icon: '🛁',
        text: '<strong>Heißes Bad 90 Min. vor dem Schlafen.</strong> Der Temperaturabfall danach signalisiert deinem Körper: Zeit zum Schlafen.',
        science: 'Klingt paradox, aber: Heißes Wasser zieht Blut an die Hautoberfläche. Wenn du aus der Wanne steigst, gibt dein Körper diese Wärme schnell ab - deine Kerntemperatur fällt rapide. Genau dieser Abfall ist das natürliche Einschlaf-Signal. Eine Meta-Analyse (University of Texas) fand, dass Bäder 1-2 Std. vor dem Schlafen die Einschlafzeit um durchschnittlich 10 Minuten verkürzen.'
      },
      {
        icon: '🧶',
        text: '<strong>Progressive Muskelentspannung.</strong> Spanne und löse jede Muskelgruppe von den Zehen bis zum Kopf.',
        science: 'Wenn du einen Muskel bewusst anspannst und dann loslässt, erhältst du eine messbar tiefere Entspannung als ohne die Anspannung davor (Kontrast-Effekt). Das aktiviert das parasympathische Nervensystem, senkt Herzfrequenz und Blutdruck. Ursprünglich von Edmund Jacobson 1929 entwickelt - heute bei Schlafkliniken Standard.'
      },
      {
        icon: '🛏️',
        text: '<strong>Deine Schlafunterlage ist entscheidend.</strong> Wenn du dich hin und her wälzt, liegt es oft an der Oberfläche.',
        science: 'Hin- und Herwälzen ist meist eine unbewusste Reaktion auf Druckpunkte oder Hitzestau. Synthetische Materialien stauen Feuchtigkeit und Wärme - dein Körper kann nicht runterkühlen, du wachst kurz auf, drehst dich. Atmungsaktive Naturfasern (Lyocell, Leinen) leiten Feuchtigkeit ab und ermöglichen die natürliche Temperaturregulation.'
      },
    ]
  },
  nature_nester: {
    name: 'Der Naturschläfer',
    title: 'Du bist ein Naturschläfer',
    description: 'Du schläfst am besten, wenn du dich in der Natur geborgen fühlst. Regen, Wind, Ozean - das sind für dich keine netten Geräusche, sie sind essenziell.',
    playlistId: '3ANlMFXFUi0VfZu9QzmU5P',
    playlistName: 'Cozy Heaven · Nature Sleep',
    playlistUrl: 'https://open.spotify.com/playlist/3ANlMFXFUi0VfZu9QzmU5P',
    songCount: 22,
    tips: [
      {
        icon: '🌿',
        text: '<strong>Fenster einen Spalt öffnen.</strong> Frische Luft und subtile Außengeräusche verbessern die Schlafqualität.',
        science: 'CO2-Konzentration im Schlafzimmer steigt nachts schnell an - bei geschlossenen Fenstern oft auf über 2.500 ppm. Eine TU Eindhoven-Studie zeigte: bei Frischluft schliefen Probanden tiefer und wachten erholter auf. Außerdem regulieren leichte Außengeräusche die Schlafphasen besser als komplette Stille.'
      },
      {
        icon: '🌧️',
        text: '<strong>Sounds schichten.</strong> Playlist + Ventilator für tiefere Immersion.',
        science: 'Konstante, breitbandige Geräusche maskieren plötzliche Störungen, die dich sonst wecken würden (Tür zuschlagen, Auto vorbei). Dein Gehirn filtert konstante Geräusche aus, reagiert aber stark auf plötzliche Veränderungen. Mehrere Schichten = mehr Maskierungseffekt.'
      },
      {
        icon: '🕯️',
        text: '<strong>"Nest"-Ritual schaffen.</strong> Gleiche Routine = Gehirn assoziiert es mit Schlaf.',
        science: 'Klassische Konditionierung (Pawlow). Wenn du immer die gleichen Schritte vor dem Schlafen machst (gleiche Sounds, gleiche Reihenfolge, gleiche Umgebung), lernt dein Gehirn: "diese Sequenz = Schlaf". Nach 2-3 Wochen löst allein der Beginn der Routine bereits Müdigkeit aus.'
      },
    ]
  },
  rhythm_resetter: {
    name: 'Der Rhythmus-Finder',
    title: 'Du bist ein Rhythmus-Finder',
    description: 'Dein Problem ist nicht das Einschlafen an sich - deine innere Uhr ist verstellt. Du brauchst Klänge mit einem langsamen, vorhersehbaren BPM.',
    playlistId: '0r3HWyD5xsTd4S2lssn25t',
    playlistName: 'Cozy Heaven · Sleep Reset',
    playlistUrl: 'https://open.spotify.com/playlist/0r3HWyD5xsTd4S2lssn25t',
    songCount: 26,
    tips: [
      {
        icon: '⏰',
        text: '<strong>Jeden Tag gleiche Aufwachzeit.</strong> Auch am Wochenende. Der #1 Sleep-Hack.',
        science: 'Dein zirkadianer Rhythmus wird hauptsächlich von der Aufwachzeit + Lichteinfall gesteuert, nicht von der Einschlafzeit. Wenn du am Wochenende 2 Std. später aufstehst, ist das wie ein Mini-Jetlag (Social Jetlag). Konstante Aufwachzeit synchronisiert deinen suprachiasmatischen Kern - die Master-Clock im Gehirn.'
      },
      {
        icon: '☀️',
        text: '<strong>Morgensonne innerhalb von 30 Min.</strong> Verankert deine innere Uhr besser als jedes Supplement.',
        science: 'Sonnenlicht am Morgen (besonders die ersten 30 Min.) trifft mit etwa 10.000 Lux auf die Netzhaut - 100x heller als jede Innenraumbeleuchtung. Das stoppt sofort die Melatonin-Produktion und startet den 16-Stunden-Wach-Countdown. Abends startet die Melatonin-Produktion dann genau zur richtigen Zeit. Stanford-Forscher Andrew Huberman nennt das den wichtigsten Hebel überhaupt.'
      },
      {
        icon: '🚫',
        text: '<strong>Kein Koffein nach 14 Uhr.</strong> Halbwertszeit: 6 Stunden.',
        science: 'Koffein blockiert Adenosin-Rezeptoren - das Molekül, das Müdigkeit signalisiert. Aber: Es wird nicht abgebaut, nur blockiert. Halbwertszeit 5-6 Stunden. Ein Kaffee um 14 Uhr = 50% Koffein noch um 20 Uhr aktiv. Selbst wenn du einschläfst, verkürzt es deinen Tiefschlaf um 30%.'
      },
    ]
  },
  story_listener: {
    name: 'Der Geschichten-Hörer',
    title: 'Du bist ein Geschichten-Hörer',
    description: 'Stille macht dich nervös, reine Klänge reichen dir nicht. Du brauchst eine sanfte Stimme oder eine Erzählung, der dein Kopf folgen kann - ohne aktiv denken zu müssen. So lässt du den Tag los, ohne dass das Gedankenkarussell übernimmt.',
    playlistId: '2J6WSQEdMgnmBJILH0QjC4',
    playlistName: 'Cozy Heaven · Sleep Stories',
    playlistUrl: 'https://open.spotify.com/playlist/2J6WSQEdMgnmBJILH0QjC4',
    songCount: 18,
    tips: [
      {
        icon: '🎙️',
        text: '<strong>Sleep Stories oder ruhige Hörbücher.</strong> Eine Stimme gibt deinem Kopf etwas zu folgen, ohne dass er selbst arbeiten muss.',
        science: 'Dein Gehirn sucht nachts nach mentaler Beschäftigung - wenn es nichts findet, fängt es an, eigene Sorgen zu produzieren. Eine sanfte Erzählung "lenkt" den Default Mode Network ab. Eine Studie der University of Oxford fand: Probanden, die Sleep Stories hörten, schliefen 37% schneller ein als die Kontrollgruppe mit reiner Musik.'
      },
      {
        icon: '⏱️',
        text: '<strong>Timer setzen.</strong> 30-45 Min. reichen meist - du sollst einschlafen, nicht die ganze Nacht zuhören.',
        science: 'Nach dem Einschlafen verarbeitet dein Gehirn weiterhin akustische Reize, auch wenn du es nicht bewusst merkst. Lange Audio-Inhalte können den Tiefschlaf stören. Ein Timer sorgt dafür, dass die Stimme verstummt, sobald du in die ersten Schlafphasen abdriftest.'
      },
      {
        icon: '🎧',
        text: '<strong>Sleep-Kopfhörer oder Lautsprecher mit niedriger Lautstärke.</strong> So leise wie möglich - gerade noch hörbar.',
        science: 'Die ideale Lautstärke liegt bei etwa 30-40 dB - leiser als Flüstern. Lauter wird das Gehirn zu aktiv und verarbeitet Worte bewusst. Bei der richtigen Lautstärke nimmt dein Gehirn die Stimme als beruhigendes Hintergrundsignal wahr, ähnlich wie ein Elternteil, das einem Kind etwas vorliest.'
      },
    ]
  },
  silence_seeker: {
    name: 'Der Stille-Sucher',
    title: 'Du bist ein Stille-Sucher',
    description: 'Du bist hochsensibel gegenüber Stimulation. Laute, komplexe Sounds halten dich eher MEHR wach. Du brauchst ultra-minimale Klanglandschaften.',
    playlistId: '46BUy2shDfbI2bcQduY2PU',
    playlistName: 'Cozy Heaven · Pure Quiet',
    playlistUrl: 'https://open.spotify.com/playlist/46BUy2shDfbI2bcQduY2PU',
    songCount: 20,
    tips: [
      {
        icon: '🔇',
        text: '<strong>Braunes statt weißes Rauschen.</strong> Tiefer, weniger hart - wie ein entfernter Wasserfall.',
        science: 'Weißes Rauschen enthält alle Frequenzen gleich stark. Braunes Rauschen betont tiefe Frequenzen und reduziert hohe - das ist sanfter für sensible Ohren. Eine Northwestern University-Studie fand: Probanden mit Schlafproblemen schliefen mit braunem Rauschen 38% schneller ein als mit weißem.'
      },
      {
        icon: '🧘',
        text: '<strong>4-7-8 Atemtechnik.</strong> 4 Sek. ein, 7 halten, 8 aus. Drei Runden reichen.',
        science: 'Der lange Ausatem-Phase aktiviert den Vagusnerv und damit das parasympathische Nervensystem ("Rest & Digest"). Innerhalb von 60-90 Sekunden sinken Herzfrequenz und Blutdruck messbar. Dr. Andrew Weil, der die Technik populär machte, nennt sie "natürlicher Tranquilizer".'
      },
      {
        icon: '🌑',
        text: '<strong>Totale Dunkelheit.</strong> Blackout-Vorhänge oder Schlafmaske.',
        science: 'Selbst durch geschlossene Augenlider registriert deine Netzhaut Licht. Schon 5 Lux (etwa Straßenlaterne durch Vorhang) reduzieren Melatonin um 50% und unterdrücken Tiefschlafphasen. Studien an Mäusen und Menschen zeigen: Schlafen in völliger Dunkelheit verbessert Insulin-Sensitivität, Stimmung und Erholung.'
      },
    ]
  }
};

// ---------- SCORING ----------
// The sound_preference question is the strongest signal because it directly
// determines what playlist the user will actually enjoy. We weight it 2x.
function calculateSleepType(answers) {
  const scores = {
    deep_dreamer: 0,
    body_melter: 0,
    nature_nester: 0,
    rhythm_resetter: 0,
    silence_seeker: 0,
    story_listener: 0,
  };

  function add(values, map, weight = 1) {
    if (!values) return;
    (Array.isArray(values) ? values : [values]).forEach(v => {
      if (map[v]) Object.entries(map[v]).forEach(([t, p]) => scores[t] += p * weight);
    });
  }

  // Q1: Sleep struggle - what causes the issue
  add(answers.sleep_struggle, {
    racing_thoughts: { deep_dreamer: 2, story_listener: 2 }, // racing thoughts can go either way
    stress: { deep_dreamer: 2, body_melter: 1, story_listener: 1 },
    restless: { body_melter: 3 },
    early_wake: { rhythm_resetter: 3 },
    screens: { rhythm_resetter: 2, deep_dreamer: 1 },
  });

  // Q2: Awake trigger
  add(answers.awake_trigger, {
    work: { deep_dreamer: 2, story_listener: 1 },
    social: { deep_dreamer: 1, story_listener: 2 }, // replays in head -> needs distraction
    physical: { body_melter: 3 },
    temperature: { body_melter: 2, nature_nester: 1 },
    noise: { silence_seeker: 3 },
  });

  // Q3: Free text keyword analysis
  const ft = (answers.safe_feeling || '').toLowerCase() + ' ' + (answers.sleep_struggle_other || '').toLowerCase() + ' ' + (answers.tired_trigger_other || '').toLowerCase();

  // Voice/narrative keywords - strong signal for story_listener
  const voiceWords = ['stimme','vorgelesen','vorlesen','vorlas','erzählt','erzählte','hörbuch','hörspiel','podcast','sleep story','asmr','geschichte','erzählung','flüster','radio','reden'];
  voiceWords.forEach(w => { if (ft.includes(w)) scores.story_listener += 3; });

  // Nature keywords
  ['regen','wind','meer','ozean','wellen','wald','natur','draußen','fenster','luft','strand','see','berge','vögel','rauschen'].forEach(w => { if (ft.includes(w)) scores.nature_nester += 2; });

  // Body/comfort keywords
  ['decke','schwer','warm','kuschel','bett','kissen','weich','einsinken','gewicht','sofa','arme','umarmt','gehalten'].forEach(w => { if (ft.includes(w)) scores.body_melter += 2; });

  // Silence keywords
  ['still','leise','ruhe','stille','nichts','dunkel','allein','komplett ruhig'].forEach(w => { if (ft.includes(w)) scores.silence_seeker += 2; });

  // Mind/thought keywords
  ['gedanken','kopf','gelesen','buch','meditation','meditiert','atmung'].forEach(w => { if (ft.includes(w)) scores.deep_dreamer += 2; });

  // Music keywords
  ['musik','melodie','klavier','klänge','piano'].forEach(w => { if (ft.includes(w)) scores.deep_dreamer += 1; });

  // Q4: Tired trigger
  add(answers.tired_trigger, {
    exercise: { body_melter: 2, rhythm_resetter: 1 },
    bath: { body_melter: 2, nature_nester: 1 },
    reading: { silence_seeker: 2, story_listener: 1 },
    meditation: { deep_dreamer: 2, silence_seeker: 1 },
    music: { nature_nester: 1, deep_dreamer: 2 },
    voice: { story_listener: 4 }, // strong signal
  });

  // Q5: Sound preference - HIGHEST WEIGHT (2x)
  // This is what playlist the user will actually want
  add(answers.sound_preference, {
    water: { nature_nester: 4 },
    piano: { deep_dreamer: 3, rhythm_resetter: 1 },
    voice: { story_listener: 5 }, // strongest single signal
    ambient: { deep_dreamer: 3, nature_nester: 1 },
    forest: { nature_nester: 4 },
    noise: { silence_seeker: 3, body_melter: 1 },
  }, 2);

  // Q6: Sleep time
  add(answers.sleep_time, {
    early: { rhythm_resetter: 1 },
    late: { rhythm_resetter: 2 },
    irregular: { rhythm_resetter: 3 },
  });

  // Q7: Goal
  add(answers.goal, {
    energy: { rhythm_resetter: 2 },
    calm: { deep_dreamer: 1, silence_seeker: 1, story_listener: 1 },
    clarity: { deep_dreamer: 1, rhythm_resetter: 1 },
    mood: { nature_nester: 1, story_listener: 1 },
    recovery: { body_melter: 2 },
  });

  return Object.entries(scores).reduce((best, [type, score]) =>
    score > best[1] ? [type, score] : best, ['deep_dreamer', 0]
  )[0];
}

// ---------- STATE ----------
let currentQuestion = 0;
let answers = {};
let userName = '';
let userEmail = '';
let showingInsight = false;

// ---------- SCREEN MANAGEMENT ----------
function showScreen(id) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  document.getElementById(id).classList.add('active');
  window.scrollTo(0, 0);
}

// ---------- QUIZ FLOW ----------
function startQuiz() {
  if (typeof fbq !== 'undefined') fbq('track', 'StartQuiz');
  showScreen('screen-quiz');
  renderQuestion();
}

function renderQuestion() {
  const q = questions[currentQuestion];
  const area = document.getElementById('quiz-question-area');
  const insightEl = document.getElementById('cloud-insight');

  // Hide insight
  insightEl.style.display = 'none';
  showingInsight = false;

  // Progress
  document.getElementById('progress-fill').style.width = `${((currentQuestion + 1) / questions.length) * 100}%`;
  document.getElementById('progress-step').textContent = currentQuestion + 1;
  document.getElementById('progress-total').textContent = questions.length;

  // Back button
  document.getElementById('btn-back').style.display = currentQuestion > 0 ? 'inline-flex' : 'none';

  let contentHTML = '';

  if (q.type === 'freetext') {
    const saved = answers[q.id] || '';
    const chipsHTML = (q.chips || []).map((chip, i) =>
      `<button class="freetext-chip" onclick="insertChip(${i})" data-chip="${i}">${chip.label}</button>`
    ).join('');

    contentHTML = `
      <div class="freetext-wrapper">
        <div class="freetext-prompts">${chipsHTML}</div>
        <textarea class="free-text-area" id="freetext-input"
          placeholder="${q.placeholder}"
          oninput="onFreeTextInput()">${saved}</textarea>
        <div class="freetext-footer">
          <span class="freetext-hint">Klick auf die Tags oben, wenn du Inspiration brauchst</span>
          <span class="char-count ${saved.length >= (q.minLength || 1) ? 'enough' : ''}" id="char-count">${saved.length >= (q.minLength || 1) ? '✓' : saved.length + '/' + (q.minLength || 1)}</span>
        </div>
      </div>
    `;
  } else {
    const selected = answers[q.id] || (q.type === 'multi' ? [] : null);
    const otherText = answers[q.id + '_other'] || '';
    const otherSelected = (selected || []).includes && (selected || []).includes('other');
    contentHTML = `
      <div class="options">
        ${q.options.map(opt => {
          const isSel = q.type === 'multi' ? (selected || []).includes(opt.value) : selected === opt.value;
          return `
            <div class="option ${isSel ? 'selected' : ''} ${opt.isOther ? 'option-other' : ''}"
                 onclick="selectOption('${q.id}', '${opt.value}', '${q.type}', this)">
              <div class="option-icon">${opt.icon}</div>
              <div class="option-content">
                <div class="option-label">${opt.label}</div>
                <div class="option-desc">${opt.desc}</div>
              </div>
              <div class="option-check"></div>
            </div>`;
        }).join('')}
      </div>
      <div class="other-input-wrapper" id="other-input-wrapper" style="display:${otherSelected ? 'block' : 'none'};">
        <input type="text" class="other-input" id="other-input" placeholder="Erzähl uns mehr..." value="${otherText.replace(/"/g, '&quot;')}" oninput="onOtherInput()">
      </div>
    `;
  }

  area.innerHTML = `
    <div class="question-wrapper">
      <div class="question-label">${q.label}</div>
      <h2 class="question-text">${q.text}</h2>
      <p class="question-sub">${q.sub}</p>
      ${contentHTML}
    </div>
  `;

  updateNextButton();
}

function insertChip(index) {
  const q = questions[currentQuestion];
  const chip = q.chips[index];
  const textarea = document.getElementById('freetext-input');
  const btn = document.querySelector(`[data-chip="${index}"]`);

  if (btn.classList.contains('used')) return;

  textarea.value += chip.text;
  answers[q.id] = textarea.value;
  btn.classList.add('used');

  textarea.focus();
  textarea.setSelectionRange(textarea.value.length, textarea.value.length);
  onFreeTextInput();
}

function selectOption(questionId, value, type, element) {
  if (type === 'multi') {
    if (!answers[questionId]) answers[questionId] = [];
    const idx = answers[questionId].indexOf(value);
    if (idx > -1) {
      answers[questionId].splice(idx, 1);
      element.classList.remove('selected');
    } else {
      answers[questionId].push(value);
      element.classList.add('selected');
    }
  } else {
    answers[questionId] = value;
    element.closest('.options').querySelectorAll('.option').forEach(o => o.classList.remove('selected'));
    element.classList.add('selected');
  }

  // Toggle "Other" free text input
  if (value === 'other') {
    const wrapper = document.getElementById('other-input-wrapper');
    if (wrapper) {
      const isSelected = element.classList.contains('selected');
      wrapper.style.display = isSelected ? 'block' : 'none';
      if (isSelected) {
        setTimeout(() => {
          const input = document.getElementById('other-input');
          if (input) input.focus();
        }, 100);
      }
    }
  }

  if (typeof fbq !== 'undefined') fbq('trackCustom', 'QuizStep', { step: currentQuestion + 1, question: questionId });

  updateNextButton();

  if (type === 'single') setTimeout(() => nextQuestion(), 300);
}

function onOtherInput() {
  const input = document.getElementById('other-input');
  const q = questions[currentQuestion];
  answers[q.id + '_other'] = input.value;
}

function onFreeTextInput() {
  const input = document.getElementById('freetext-input');
  const q = questions[currentQuestion];
  answers[q.id] = input.value;
  const min = q.minLength || 1;
  const count = input.value.length;
  const el = document.getElementById('char-count');
  if (count >= min) {
    el.textContent = '✓';
    el.classList.add('enough');
  } else {
    el.textContent = count + '/' + min;
    el.classList.remove('enough');
  }
  updateNextButton();
}

function updateNextButton() {
  const q = questions[currentQuestion];
  const btn = document.getElementById('btn-next');
  let ok = false;
  if (q.type === 'freetext') ok = (answers[q.id] || '').length >= (q.minLength || 1);
  else if (q.type === 'multi') ok = (answers[q.id] || []).length > 0;
  else ok = !!answers[q.id];
  btn.disabled = !ok;
}

function nextQuestion() {
  const q = questions[currentQuestion];
  if (q.type === 'multi' && (!answers[q.id] || answers[q.id].length === 0)) return;
  if (q.type === 'single' && !answers[q.id]) return;
  if (q.type === 'freetext' && (answers[q.id] || '').length < (q.minLength || 1)) return;

  // Check if there's a cloud insight to show
  if (cloudInsights[currentQuestion] && !showingInsight) {
    showCloudInsight(currentQuestion);
    return;
  }

  if (currentQuestion < questions.length - 1) {
    currentQuestion++;
    renderQuestion();
  } else {
    showEmailCapture();
  }
}

function showCloudInsight(afterIndex) {
  const insight = cloudInsights[afterIndex];
  const area = document.getElementById('quiz-question-area');
  const insightEl = document.getElementById('cloud-insight');

  // Hide question, show insight
  area.querySelector('.question-wrapper').style.display = 'none';
  insightEl.style.display = 'block';
  insightEl.style.animation = 'none';
  // Trigger reflow for animation restart
  void insightEl.offsetWidth;
  insightEl.style.animation = 'insightPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';

  document.getElementById('insight-face').textContent = insight.face;
  document.getElementById('insight-text').innerHTML = insight.text;

  showingInsight = true;

  // Change next button temporarily
  const btn = document.getElementById('btn-next');
  btn.disabled = false;
  btn.innerHTML = 'Weiter <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

function prevQuestion() {
  if (showingInsight) {
    // Go back to the question from insight
    showingInsight = false;
    renderQuestion();
    return;
  }
  if (currentQuestion > 0) {
    currentQuestion--;
    renderQuestion();
  }
}

// ---------- EMAIL CAPTURE ----------
function showEmailCapture() {
  if (typeof fbq !== 'undefined') fbq('track', 'QuizComplete');

  // Update song count based on sleep type
  const typeKey = calculateSleepType(answers);
  const type = sleepTypes[typeKey];
  document.getElementById('preview-songs').textContent = type.songCount + ' Songs';

  showScreen('screen-email');
  setTimeout(() => document.getElementById('name-input').focus(), 400);
}

function updatePreviewName() {
  const name = document.getElementById('name-input').value.trim();
  document.getElementById('preview-title').textContent = name
    ? `Cozy Heaven für ${name}`
    : 'Cozy Heaven für dich';
}

function submitEmail() {
  const nameInput = document.getElementById('name-input');
  const emailInput = document.getElementById('email-input');
  const name = nameInput.value.trim();
  const email = emailInput.value.trim();

  if (!name) {
    nameInput.style.borderColor = '#c0392b';
    setTimeout(() => nameInput.style.borderColor = '', 2000);
    nameInput.focus();
    return;
  }
  if (!email || !isValidEmail(email)) {
    emailInput.style.borderColor = '#c0392b';
    setTimeout(() => emailInput.style.borderColor = '', 2000);
    emailInput.focus();
    return;
  }

  userName = name;
  userEmail = email;

  if (typeof fbq !== 'undefined') fbq('track', 'Lead', { content_name: 'sleep_quiz' });

  // TODO: ESP Integration (Klaviyo)
  // fetch('https://a.klaviyo.com/api/v2/list/LIST_ID/subscribe', { ... })

  try {
    const leads = JSON.parse(localStorage.getItem('cozy_quiz_leads') || '[]');
    leads.push({ name, email, answers, sleepType: calculateSleepType(answers), timestamp: new Date().toISOString() });
    localStorage.setItem('cozy_quiz_leads', JSON.stringify(leads));
  } catch (e) {}

  showAnalyzing();
}

function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

// ---------- ANALYZING ----------
function showAnalyzing() {
  showScreen('screen-analyzing');

  const steps = [
    { id: 'step-1', text: '✓ Schlafmuster erkannt', delay: 800 },
    { id: 'step-2', text: '✓ Frequenzen abgestimmt', delay: 1800 },
    { id: 'step-3', text: '✓ Tracks ausgewählt', delay: 2800 },
    { id: 'step-4', text: '✓ Playlist finalisiert', delay: 3600 },
  ];

  const statuses = [
    'Schlafprofil wird analysiert...',
    'Frequenzen werden abgestimmt...',
    'Tracks aus 10.000+ Schlaf-Sounds...',
    'Fast fertig...',
  ];

  steps.forEach((step, i) => {
    setTimeout(() => {
      document.getElementById(step.id).classList.add('done');
      document.getElementById(step.id).innerHTML = step.text;
      if (i < steps.length - 1) document.getElementById(steps[i + 1].id).classList.add('active');
      document.getElementById('analyzing-status').textContent = statuses[i];
    }, step.delay);
  });

  setTimeout(() => showResults(), 4200);
}

// ---------- RESULTS ----------
function showResults() {
  const typeKey = calculateSleepType(answers);
  const type = sleepTypes[typeKey];

  if (typeof fbq !== 'undefined') fbq('trackCustom', 'SleepTypeResult', { sleep_type: typeKey });

  document.getElementById('sleep-type-badge').textContent = type.name;
  document.getElementById('result-title').textContent = type.title;
  document.getElementById('result-description').textContent = type.description;
  document.getElementById('playlist-name').textContent = `Cozy Heaven für ${userName || 'dich'}`;

  document.getElementById('playlist-embed').innerHTML = `
    <iframe src="https://open.spotify.com/embed/playlist/${type.playlistId}?utm_source=generator&theme=0"
      width="100%" height="352"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy" style="border-radius:12px;"></iframe>
  `;

  document.getElementById('playlist-link').href = type.playlistUrl;

  document.getElementById('sleep-tips').innerHTML = `
    <h3>💡 Schlaf-Tipps für ${type.name}</h3>
    ${type.tips.map((t, i) => `
      <div class="tip">
        <div class="tip-icon">${t.icon}</div>
        <div class="tip-body">
          <div class="tip-text">${t.text}</div>
          ${t.science ? `
            <button class="tip-science-toggle" onclick="toggleScience(${i})" id="science-btn-${i}">
              <span class="science-icon">🔬</span> Warum funktioniert das?
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" class="science-chevron"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
            <div class="tip-science" id="science-${i}">${t.science}</div>
          ` : ''}
        </div>
      </div>
    `).join('')}
  `;

  showScreen('screen-results');
}

// ---------- REMINDER ----------
function activateReminder() {
  const time = document.getElementById('reminder-time').value;

  if (typeof fbq !== 'undefined') fbq('trackCustom', 'ReminderActivated', { time });

  // TODO: Hook into ESP to trigger time-based email/push
  // For now, store preference
  try {
    const leads = JSON.parse(localStorage.getItem('cozy_quiz_leads') || '[]');
    const last = leads[leads.length - 1];
    if (last) { last.reminderTime = time; localStorage.setItem('cozy_quiz_leads', JSON.stringify(leads)); }
  } catch (e) {}

  document.querySelector('.reminder-time-picker').style.display = 'none';
  document.getElementById('reminder-success').style.display = 'block';
}

// ---------- TOOLTIPS & EXPANDABLES ----------
function toggleTooltip(id, event) {
  if (event) event.stopPropagation();
  const tooltip = document.getElementById(id);
  if (!tooltip) return;
  const isVisible = tooltip.classList.contains('visible');
  document.querySelectorAll('.tooltip.visible').forEach(t => t.classList.remove('visible'));
  if (!isVisible) tooltip.classList.add('visible');
}

document.addEventListener('click', (e) => {
  if (!e.target.closest('.input-with-tooltip')) {
    document.querySelectorAll('.tooltip.visible').forEach(t => t.classList.remove('visible'));
  }
});

function toggleScience(index) {
  const science = document.getElementById('science-' + index);
  const btn = document.getElementById('science-btn-' + index);
  if (!science) return;
  const isOpen = science.classList.contains('open');
  if (isOpen) {
    science.classList.remove('open');
    btn.classList.remove('open');
  } else {
    science.classList.add('open');
    btn.classList.add('open');
  }
}

// ---------- SHARING ----------
function shareQuiz(platform) {
  const url = encodeURIComponent(window.location.href);
  const text = encodeURIComponent('Ich hab gerade meinen Schlaftyp entdeckt und eine kostenlose Schlaf-Playlist bekommen! 🌙 Finde deinen:');

  switch (platform) {
    case 'whatsapp': window.open(`https://wa.me/?text=${text}%20${url}`, '_blank'); break;
    case 'facebook': window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank'); break;
    case 'copy':
      navigator.clipboard.writeText(window.location.href).then(() => {
        const btn = event.target;
        btn.textContent = 'Kopiert!';
        setTimeout(() => btn.textContent = 'Link kopieren', 2000);
      });
      break;
  }

  if (typeof fbq !== 'undefined') fbq('trackCustom', 'ShareQuiz', { platform });
}
